<template>
    <v-container fluid>
        <steps-form v-model="item" :editState="editState" @next_step="gotoNewTask" @list="gotoList"></steps-form>
    </v-container>
</template>

<script>
import StepsForm from "@/components/Problem/Steps/NewDataStepsForm";
import clone from "lodash.clonedeep";

export default {
    components: {StepsForm},
    data() {
        return {
            item: {},
            editState: {},
            ACTION_LOAD: 'problem/loadItems',
            ACTION_NEW: 'problem/newItem',
            ACTION_SAVE: 'problem/saveItem',
            ACTION_SET_EDIT_ITEM: 'problem/setEditItem',
            ROUTE_LIST: 'problemsList',
            STORE_MODULE: 'problem'
        }
    },
    async created() {
        this.$store.commit('task/setWellsItem', null);
        this.$store.commit('grid/resetData');

        if (this.itemId) {
            await this.load();
            await this.$store.dispatch(this.ACTION_SET_EDIT_ITEM, this.itemId);
        }
    },
    watch: {
        async itemId() {
            this.$store.commit('grid/resetData');
            await this.load();
        },
        parsedProblem() {
            let newItem = Object.assign({}, this.parsedProblem);
            if (this.itemId && !newItem.id) {
                newItem.id = this.itemId;
                newItem.name = this.item.name;
            }

            this.item = newItem;
        },
    },
    methods: {
        async save() {
            let item = clone(this.item);
            if (!item.reservoir) {
                item.reservoir = {}
            }

            if (!item.wells) {
                item.wells = [];
            }

            await this.$store.dispatch(this.ACTION_SAVE, item);
        },
        async load() {
            let item = await this.$store.dispatch('problem/loadItem', this.itemId);
            console.log('load', item);
            if (item?.problem) {
                this.item = item?.problem;
                this.editState = item?.state;

                if (item?.tasks && item?.tasks?.length > 0) {
                    let task = item?.tasks[0];
                    if (task.type === 'base') {
                        this.task = task
                    }

                    if (task.type === 'predict') {
                        this.predictTask = task;
                    }

                    if (task.type === 'wells') {
                        this.wellsTask = task;
                    }
                }
            }
            else if (item) {
                this.item = item;
            }
        },
        gotoNewTask() {
            this.$router.push({ name: 'taskNew', params: { id: this.item.id } });
        },
        gotoList() {
            return this.$router.push({ name: 'problemsList' });
        }
    },
    computed: {
        itemId() {
            return this.$route.params && this.$route.params.id
                ? this.$route.params.id || false
                : false;
        },
        storeEditState() {
            return this.$store.state.problem.editState;
        },
        parsedProblem() {
            return this.$store.state.grid.parsedProblem;
        }
    }
}
</script>

<style lang="scss">
    .problem-edit {
        height: 100%;
        position: relative;
    }
</style>
